import Constants from '../Constants';
import * as Helpers from '../Utilities/Common';
import { normalizeData } from '../Schemas';
import { toggleModal } from './ModalActions';


const { GET_COMPANIES, COMPANIES_LOADING, ADD_COMPANY, ADD_COMPANY_FAIL, DELETE_COMPANY, UPDATE_COMPANY, UPDATE_COMPANY_FAIL, RESET_COMPANIES_ALERT } = Constants;

export const getCompanies = (token, newQuery = {}, append = true) => async (dispatch, getState) => {
    
    let query = { page: 1, per_page:15 };

    if(newQuery !== false){
        query = append ? { ...getState().companyStore.query, ...newQuery } : newQuery;
    }

    dispatch(companyLoading());

    const response = await Helpers.makeRequest(token,"COMPANIES","GET","",query);

    if(response.result){
        const normalizedData = normalizeData(response.data,"companies");

        dispatch({ type: GET_COMPANIES, payload: { data: normalizedData, query: query} });
        dispatch({ type: RESET_COMPANIES_ALERT, payload: true });
    }
}

export const resetAlert = () => (dispatch) => {
    dispatch({ type: RESET_COMPANIES_ALERT, payload: true });
}

export const companyLoading = () => ({ type: COMPANIES_LOADING, payload: true });


export const deleteCompany = (token,id) => async (dispatch) => {

    const response = await Helpers.makeRequest(token,'COMPANIES','DELETE','','',id);
    if(response.result){
        dispatch({ type: DELETE_COMPANY, payload: id });
    }
}

export const addCompany = (token,data,permissions) => async (dispatch) => {
    
    const { name = "", short_name = "", website = "", address = "", contact_email = "", contact_phone = "", contact_name = "", type = "", comment = "" } = data;
    let formData = { name, short_name, website, address, contact_email, contact_phone, contact_name, type, comment };
    
    const response = await Helpers.makeRequest(token,'COMPANIES','POST',formData);

    if(response.result){
        //dispatching action ADD_COMPANY causes the previous companies state to refresh
        dispatch({ type: ADD_COMPANY, payload: true });
        dispatch(toggleModal("companies","add"));
        //getting companies again. Doing this on purpose
        dispatch(getCompanies(token));
    }else{
        dispatch({ type: ADD_COMPANY_FAIL, payload: response.data });
    }
}

export const editCompany = (token, data, permissions, id) => async (dispatch) => {
    const { name = "", short_name = "", website = "", address = "", contact_email = "", contact_phone = "", contact_name = "", type = "", comment = "" } = data;
    let formData = { name, short_name, website, address, contact_email, contact_phone, contact_name, type, comment };

    const response = await Helpers.makeRequest(token,'COMPANIES','PUT',formData,'',id);
    if(response.result){
        dispatch({ type: UPDATE_COMPANY, payload: response.data.company });
        dispatch(toggleModal("companies","add"));
    }else{
        dispatch({ type: UPDATE_COMPANY_FAIL, payload: response.data });
    }
}





// WEBPACK FOOTER //
// ./src/Actions/CompanyActions.js